'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response(origin, files) {
  this.X4 = null;
  this.X3 = null;
  this.X4 = origin;
  this.X3 = files;
}
export { $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response as $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response };
$p = $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response;
/** @constructor */
function $h_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response() {
}
export { $h_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response as $h_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response };
$h_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response)) {
    if ((this.X4 === x$0.X4)) {
      var x = this.X3;
      var x$2 = x$0.X3;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "LocalPjeOfficeSignFileBase64Response";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.X4;
  }
  if ((n === 1)) {
    return this.X3;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hD)));
}
export { $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response as $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response };
var $d_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response, "presto.AgentView$LocalPjeOfficeSignFileBase64Response", ({
  hD: 1,
  bv: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response as $d_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response };
//# sourceMappingURL=presto.-Agent-View$-Local-Pje-Office-Sign-File-Base64-Response.js.map
